import React from "react";
import "./businessTypesDropDown.css";
import BusinessDropDownOption from "./BusinessDropDownOption";

const BusinessTypesDropDown = ({
  isMobile,
  showDropDown,
  showMobileDropDown,
}) => {
  return (
    <>
      <div
        className={`drop-down-menu business-menu-card ${
          showDropDown === 2 ? "drop-down-menu-show" : ""
        } ${isMobile ? "mobile-dropDown" : ""} ${
          showMobileDropDown === 2 ? "mobile-dropDown-show" : ""
        }`}
      >
        <div className="drop-down-menu-body">
          <img src="./images/menu-icons/triangle.svg" className="tip" alt="" />
          <div className="row drop-down-options px-4 py-4">
            <div className="col-4 p-0 category">
              <h3 className="category-heading">Beauty</h3>
              <div className="category-options">
                <BusinessDropDownOption
                  icon="./images/menu-icons/scessior.svg"
                  title="Salon"
                  pageLink="/salon-software"
                />
                <BusinessDropDownOption
                  icon="./images/menu-icons/nail.svg"
                  title="Nail"
                  pageLink="/nail-salon-software"
                />
                <BusinessDropDownOption
                  icon="./images/menu-icons/barber.svg"
                  title="Barber"
                  pageLink="/barber-software"
                />
                <BusinessDropDownOption
                  icon="./images/menu-icons/tattoo.svg"
                  title="Tattoo"
                  pageLink="/tatoo-shop-software"
                />
                <BusinessDropDownOption
                  icon="./images/menu-icons/training.svg"
                  title="Training"
                  pageLink="/training-salon-software"
                />
                <BusinessDropDownOption
                  icon="./images/menu-icons/makeup.svg"
                  title="Makeup"
                  pageLink="/makeup-artist-software"
                />
                <BusinessDropDownOption
                  icon="./images/menu-icons/hair.svg"
                  title="Hair Removal"
                  pageLink="/hair-removal-studio-software"
                />
                <BusinessDropDownOption
                  icon="./images/menu-icons/beauty.svg"
                  title="Beauty"
                  pageLink="/brow-lash-software"
                />
              </div>
            </div>
            <div className="col-4 p-0 category">
              <h3 className="category-heading">Wellness</h3>
              <div className="category-options">
                <BusinessDropDownOption
                  icon="./images/menu-icons/spa.svg"
                  title="Spa"
                  pageLink="/spa-software"
                />
                <BusinessDropDownOption
                  icon="./images/menu-icons/massage.svg"
                  title="Massage"
                  pageLink="/massage-software"
                />
                <BusinessDropDownOption
                  icon="./images/menu-icons/coaching.svg"
                  title="Coaching"
                  pageLink="/coaching-software"
                />
                <BusinessDropDownOption
                  icon="./images/menu-icons/pin.svg"
                  title="Acupunture"
                  pageLink="/acupuncture-software"
                />
                <BusinessDropDownOption
                  icon="./images/menu-icons/pt.svg"
                  title="Physical Therapy"
                  pageLink="/physical-therapy-software"
                />
                <BusinessDropDownOption
                  icon="./images/menu-icons/apple.svg"
                  title="Nutritionist"
                  pageLink="/nutritionist-software"
                />
                <BusinessDropDownOption
                  icon="./images/menu-icons/bone.svg"
                  title="Chiropractor"
                  pageLink="/chiropractor-software"
                />
                <BusinessDropDownOption
                  icon="./images/menu-icons/pt.svg"
                  title="Med Spa"
                  pageLink="/medical-spa-software"
                />
                <BusinessDropDownOption
                  icon="./images/menu-icons/mental health.svg"
                  title="Mental Health"
                  pageLink="/mental-health-software"
                />
              </div>
            </div>
            <div className="col-4 p-0 category">
              <h3 className="category-heading">Fitness</h3>
              <div className="category-options">
                <BusinessDropDownOption
                  icon="./images/menu-icons/pilates.svg"
                  title="Pilates"
                  pageLink="/pilates-software"
                />
                <BusinessDropDownOption
                  icon="./images/menu-icons/yoga.svg"
                  title="Yoga"
                  pageLink="/yoga-software"
                />
                <BusinessDropDownOption
                  icon="./images/menu-icons/ptrainer.svg"
                  title="Personal Trainer"
                  pageLink="/personal-training-software"
                />
                <BusinessDropDownOption
                  icon="./images/menu-icons/watch.svg"
                  title="Gross Training"
                  pageLink="/cross-training-software"
                />
                <BusinessDropDownOption
                  icon="./images/menu-icons/cycling.svg"
                  title="Cycling"
                  pageLink="/cycling-software"
                />
                <BusinessDropDownOption
                  icon="./images/menu-icons/dance.svg"
                  title="Dance"
                  pageLink="/dancing-studio-software"
                />
                <BusinessDropDownOption
                  icon="./images/menu-icons/gym.svg"
                  title="Gym"
                  pageLink="/gym-software"
                />
                <BusinessDropDownOption
                  icon="./images/menu-icons/fitnes.svg"
                  title="All Fitness"
                  pageLink="/fitness-software"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default BusinessTypesDropDown;
